module.exports = __webpack_public_path__ + "img/skate.8d041fde.jpg";